module.exports = __webpack_public_path__ + "static/media/icon_tutorial.ca3f93c1.svg";